import { Route, Routes } from '@angular/router';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { CanDeactivateGuard } from '@shared/guards/can-deactivate.guard';

import { PeriodCloseComponent } from './period-close.component';
import { InvoicesGuard } from './tabs/invoices-and-prepaids/invoices/guards/invoices.guard';
import { InvoiceDetailComponent } from './tabs/invoices-and-prepaids/invoices/invoice-detail/invoice-detail.component';
import { InvoicesComponent } from './tabs/invoices-and-prepaids/invoices/invoices.component';
import { InvoicesAndPrepaidsComponent } from './tabs/invoices-and-prepaids/invoices-and-prepaids.component';
import { PrepaidsGuard } from './tabs/invoices-and-prepaids/prepaids/guards/prepaids.guard';
import { PrepaidDetailComponent } from './tabs/invoices-and-prepaids/prepaids/prepaid-detail/prepaid-detail.component';
import { PrepaidsComponent } from './tabs/invoices-and-prepaids/prepaids/prepaids.component';
import { JournalEntriesGuard } from './tabs/journal-entries/guards/journal-entries.guard';
import { JournalEntriesComponent } from './tabs/journal-entries/journal-entries.component';
import { QuarterCloseComponent } from './tabs/quarter-close/quarter-close.component';
import { QuarterCloseGuard } from './tabs/quarter-close/quarter-close.guard';
import { QuarterCloseAdjustmentsComponent } from './tabs/quarter-close-adjustments/quarter-close-adjustments.component';
import { QuarterCloseAdjustmentsGuard } from './tabs/quarter-close-adjustments/quarter-close-adjustments.guard';
import { QuarterCloseChecklistComponent } from './tabs/quarter-close-checklist/quarter-close-checklist.component';
import { QuarterCloseChecklistGuard } from './tabs/quarter-close-checklist/quarter-close-checklist.guard';
import { ReconciliationGuard } from './tabs/reconciliation/guards/reconciliation.guard';
import { ReconciliationComponent } from './tabs/reconciliation/reconciliation.component';

const invoicesSubRoutes = [
  {
    canActivate: [InvoicesGuard],
    canDeactivate: [CanDeactivateGuard],
    component: InvoicesComponent,
    path: ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INVOICES,
  },
  {
    canActivate: [PrepaidsGuard],
    canDeactivate: [CanDeactivateGuard],
    component: PrepaidsComponent,
    path: ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.PREPAIDS,
  },
  {
    canActivate: [PrepaidsGuard],
    canDeactivate: [CanDeactivateGuard],
    component: PrepaidDetailComponent,
    path: `${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.PREPAIDS}/:id`,
  },
  {
    canActivate: [InvoicesGuard],
    canDeactivate: [CanDeactivateGuard],
    component: InvoiceDetailComponent,
    path: `${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INVOICES}/:id`,
  },
  {
    path: '**',
    redirectTo: ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INVOICES,
  },
];

export const buildPeriodCloseRoutes = (): Route => {
  const allRoutes: Routes = [
    {
      canActivate: [QuarterCloseChecklistGuard],
      canDeactivate: [CanDeactivateGuard],
      component: QuarterCloseChecklistComponent,
      path: ROUTING_PATH.CLOSING.CHECKLIST,
    },
    {
      canActivate: [QuarterCloseAdjustmentsGuard],
      canDeactivate: [CanDeactivateGuard],
      component: QuarterCloseAdjustmentsComponent,
      path: ROUTING_PATH.CLOSING.EXPENSE_DETAIL,
    },
    {
      canActivate: [QuarterCloseGuard],
      canDeactivate: [CanDeactivateGuard],
      component: QuarterCloseComponent,
      path: ROUTING_PATH.CLOSING.CLOSE_SUMMARY,
    },
    {
      canDeactivate: [CanDeactivateGuard],
      children: invoicesSubRoutes,
      component: InvoicesAndPrepaidsComponent,
      path: ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INDEX,
    },
    {
      canActivate: [ReconciliationGuard],
      canDeactivate: [CanDeactivateGuard],
      component: ReconciliationComponent,
      path: ROUTING_PATH.CLOSING.RECONCILIATION,
    },
    {
      canActivate: [JournalEntriesGuard],
      canDeactivate: [CanDeactivateGuard],
      component: JournalEntriesComponent,
      path: ROUTING_PATH.CLOSING.JOURNAL_ENTRIES,
    },
  ];

  return {
    children: [...allRoutes, { path: '**', redirectTo: ROUTING_PATH.CLOSING.CLOSE_SUMMARY }],
    component: PeriodCloseComponent,
    path: ROUTING_PATH.CLOSING.INDEX,
  };
};
